'use strict';

/** @type {import('./syntax')} */
module.exports = SyntaxError;



//////////////////
// WEBPACK FOOTER
// ./~/es-errors/syntax.js
// module id = 34
// module chunks = 20216485166878 72576805601409 114276838955818 211741474912242 256957939565513